import { registerSW } from "virtual:pwa-register";

/**
 * SERVICE WORKER KAYDI
 *
 * ================================================================
 * `registerType: "prompt"` — GUNCELLEME KULLANICIYA SORULUR
 * ================================================================
 * `autoUpdate` olsaydi yeni surum indirilir indirilmez sayfa
 * yenilenirdi. Ogrenci veri girerken bunun olmasi, yazdigi seyi
 * kaybetmesi demek — hem de neden olduğunu anlamadan.
 *
 * Bu yuzden guncelleme HAZIR oldugunda yalnizca haber veriliyor;
 * uygulamayi yenileme kararini kullanici veriyor.
 *
 * Kuyruk zaten IndexedDB'de: yenileme sirasinda veri kaybolmuyor.
 * Ama form icindeki YAZILMAMIS giris kayboluyor ve o fark yeterince
 * onemli.
 */

export interface PwaDurumu {
  /** Yeni surum indirildi, yenileme bekliyor */
  guncellemeHazir: boolean;
  /** Uygulama cevrimdisi kullanima hazir */
  cevrimdisiHazir: boolean;
}

type Dinleyici = (durum: PwaDurumu) => void;

const durum: PwaDurumu = { guncellemeHazir: false, cevrimdisiHazir: false };
const dinleyiciler = new Set<Dinleyici>();

function yayinla(): void {
  for (const d of dinleyiciler) d({ ...durum });
}

export function pwaDinle(d: Dinleyici): () => void {
  dinleyiciler.add(d);
  d({ ...durum });
  return () => dinleyiciler.delete(d);
}

let yenileyici: ((yeniden?: boolean) => Promise<void>) | null = null;

/** Kullanici "yenile" dediginde. */
export async function pwaGuncelle(): Promise<void> {
  await yenileyici?.(true);
}

/**
 * Kaydi baslatir.
 *
 * Gelistirmede service worker KAPALI (`devOptions.enabled: false`):
 * acik olsaydi Vite'in sicak yeniden yuklemesi onbellekle catisir ve
 * "degistirdigim kod neden gorunmuyor" saatleri baslardi.
 */
export function pwaBaslat(): void {
  // `import.meta.env.DEV` gelistirmede true. Kaydi hic denemiyoruz.
  if (import.meta.env.DEV) return;

  yenileyici = registerSW({
    immediate: true,
    onNeedRefresh() {
      durum.guncellemeHazir = true;
      yayinla();
    },
    onOfflineReady() {
      durum.cevrimdisiHazir = true;
      yayinla();
    },
  });
}
